import { CheckAPIAndDeleteAnimalUseCase } from './CheckAPIAndDeleteAnimalUseCase';
import { AnimalRepository } from '../../repositories/AnimalRepository';
import { ITable } from '../../../../../ApiManager';
import { IAnimal } from '../../entities/IAnimal';

type Arguments = {
  table: ITable;
  propriedade_id: string;
  animalsApi: IAnimal[];
};

export async function CheckAPIAndDeleteAnimalController({
  table,
  propriedade_id,
  animalsApi,
}: Arguments) {
  const useCase = new CheckAPIAndDeleteAnimalUseCase(
    new AnimalRepository(table.animais),
  );

  await useCase.execute({ propriedade_id, animalsApi });
}
